import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getApplicationInfo } from "@/api/v1-jwt/provider-onboarding/provider-onboarding";
import { ApplicationInfoResponse } from "./types";
import providerOnboardingQueryKeys from "./query-keys";

export const useApplicationInfo = (
  userId: string,
  providerType: string,
  options?: Omit<UseQueryOptions<ApplicationInfoResponse, Error>, "queryKey" | "queryFn">
) => {
  return useQuery<ApplicationInfoResponse, Error>({
    queryKey: providerOnboardingQueryKeys.applicationInfo(userId, providerType),
    queryFn: () => getApplicationInfo(userId, providerType),
    enabled: !!userId && !!providerType,
    staleTime: Infinity,
    retry: false,
    ...options,
  });
};
